import type { ContributorType, LanguageType, PermissionType } from '@app/api/contributors';
import type { TeamUserGroup } from '@app/api/team';

export { generateContributor } from './generateContributor';

export const userGroupsMock: TeamUserGroup[] = [
    {
        id: 4616,
        avatar: 'https://app.lokalise.local/icons/characters/icon_24.png',
        name: 'Developers',
        allEditableLanguages: false,
        allReadOnlyLanguages: false,
        roleId: null,
        readOnlyLanguages: [
            {
                id: '714',
                isoCode: 'ar',
                name: 'Arabic',
            },
        ],
        editableLanguages: [
            {
                id: '666',
                isoCode: 'de',
                name: 'German',
            },
        ],
        projects: [
            {
                id: '6761537965c4a3903ed0b9.77815942',
                name: 'Permissions',
            },
        ],
        permissions: [
            {
                id: 'tasks',
                scope: 'project',
                title: 'Tasks',
                group: 'Project',
                checked: false,
                enabled: true,
            },
            {
                id: 'upload',
                scope: 'project',
                title: 'Upload',
                group: 'Content transfer',
                checked: false,
                enabled: true,
            },
            {
                id: 'activity',
                scope: 'project',
                title: 'Activity',
                group: 'Activity',
                checked: false,
                enabled: true,
            },
            {
                id: 'download',
                scope: 'project',
                title: 'Download',
                group: 'Content transfer',
                checked: false,
                enabled: true,
            },
            {
                id: 'glossary',
                scope: 'project',
                title: 'Glossary',
                group: 'Glossary',
                checked: false,
                enabled: true,
            },
            {
                id: 'settings',
                scope: 'project',
                title: 'Settings',
                group: 'Project',
                checked: false,
                enabled: true,
            },
            {
                id: 'statistics',
                scope: 'project',
                title: 'Statistics',
                group: 'Activity',
                checked: false,
                enabled: true,
            },
            {
                id: 'manage_keys',
                scope: 'project',
                title: 'Manage keys',
                group: 'Content',
                checked: false,
                enabled: true,
            },
            {
                id: 'screenshots',
                scope: 'project',
                title: 'Screenshots',
                group: 'Content',
                checked: false,
                enabled: true,
            },
            {
                id: 'contributors',
                scope: 'project',
                title: 'Contributors',
                group: 'Project',
                checked: false,
                enabled: true,
            },
            {
                id: 'branches_create',
                scope: 'project',
                title: 'Create branches',
                group: 'Branches',
                checked: false,
                enabled: true,
            },
            {
                id: 'branches_merge',
                scope: 'project',
                title: 'Merge branches',
                group: 'Branches',
                checked: false,
                enabled: true,
            },
            {
                id: 'manage_languages',
                scope: 'project',
                title: 'Manage languages',
                group: 'Project',
                checked: false,
                enabled: true,
            },
            {
                id: 'review',
                scope: 'project',
                title: 'Review and change status',
                group: 'Review',
                checked: false,
                enabled: true,
            },
        ],
        contributors: [
            {
                id: 114330,
                name: 'Mohamed Mounir',
                email: 'mohamed.mounir@lokalise.com',
                avatar: 'https://www.gravatar.com/avatar/2fb76ddb5fb51821b58819c9900be54c?d=retro\u0026s=100',
                groups: [
                    {
                        id: '4616',
                        name: 'Developers',
                    },
                ],
            },
        ],
    },
];

export const languagesMock: LanguageType[] = [
    {
        id: '714',
        isoCode: 'ar',
        label: 'Arabic',
        base: true,
    },
    {
        id: '666',
        isoCode: 'de',
        label: 'German',
        base: false,
    },
    {
        id: '734',
        isoCode: 'it',
        label: 'Italian',
        base: false,
    },
    {
        id: '643',
        isoCode: 'ja',
        label: 'Japanese',
        base: false,
    },
    {
        id: '10153',
        isoCode: 'lv',
        label: 'Latvian',
        base: false,
    },
    {
        id: '770',
        isoCode: 'ro',
        label: 'Romanian',
        base: false,
    },
    {
        id: '783',
        isoCode: 'sr',
        label: 'Serbian',
        base: false,
    },
    {
        id: '754',
        isoCode: 'sv',
        label: 'Swedish',
        base: false,
    },
    {
        id: '808',
        isoCode: 'sw',
        label: 'Swahili',
        base: false,
    },
    {
        id: '753',
        isoCode: 'th',
        label: 'Thai',
        base: false,
    },
    {
        id: '673',
        isoCode: 'fr',
        label: 'French',
        base: false,
    },
    {
        id: '10154',
        isoCode: 'et',
        label: 'Estonian ',
        base: false,
    },
    {
        id: '640',
        isoCode: 'en',
        label: 'English',
        base: false,
    },
    {
        id: '793',
        isoCode: 'hr',
        label: 'Croatian',
        base: false,
    },
    {
        id: '745',
        isoCode: 'fa',
        label: 'Persian',
        base: false,
    },
    {
        id: '956',
        isoCode: 'ur',
        label: 'Urdu',
        base: false,
    },
    {
        id: '602',
        isoCode: 'zh_CN',
        label: 'Chinese Simplified',
        base: false,
    },
];

export const permissionsMock: PermissionType[] = [
    {
        id: 'tasks',
        scope: 'project',
        title: 'Manage tasks',
        group: 'Project',
        dependentPermissions: [],
        newPermission: false,
        doesSetAllReadOnlyLanguages: true,
        description: null,
    },
    {
        id: 'upload',
        scope: 'project',
        title: 'Upload files',
        group: 'Content transfer',
        dependentPermissions: ['branches_main_modify'],
        newPermission: false,
        doesSetAllReadOnlyLanguages: true,
        description: null,
    },
    {
        id: 'activity',
        scope: 'project',
        title: 'View activity',
        group: 'Activity',
        dependentPermissions: [],
        newPermission: false,
        doesSetAllReadOnlyLanguages: false,
        description: null,
    },
    {
        id: 'download',
        scope: 'project',
        title: 'Download files',
        group: 'Content transfer',
        dependentPermissions: [],
        newPermission: false,
        doesSetAllReadOnlyLanguages: false,
        description: null,
    },
    {
        id: 'glossary_edit',
        scope: 'project',
        title: 'Add and edit glossary terms',
        group: 'Glossary',
        dependentPermissions: [],
        newPermission: false,
        doesSetAllReadOnlyLanguages: false,
        description: null,
    },
    {
        id: 'glossary_delete',
        scope: 'project',
        title: 'Delete glossary terms',
        group: 'Glossary',
        dependentPermissions: ['glossary_edit'],
        newPermission: false,
        doesSetAllReadOnlyLanguages: false,
        description: null,
    },
    {
        id: 'settings',
        scope: 'project',
        title: 'Manage project settings',
        group: 'Project',
        dependentPermissions: [],
        newPermission: false,
        doesSetAllReadOnlyLanguages: true,
        description: null,
    },
    {
        id: 'statistics',
        scope: 'project',
        title: 'View statistics',
        group: 'Activity',
        dependentPermissions: [],
        newPermission: false,
        doesSetAllReadOnlyLanguages: false,
        description: null,
    },
    {
        id: 'manage_keys',
        scope: 'project',
        title: 'Manage keys',
        group: 'Content',
        dependentPermissions: ['branches_main_modify'],
        newPermission: false,
        doesSetAllReadOnlyLanguages: true,
        description: null,
    },
    {
        id: 'screenshots',
        scope: 'project',
        title: 'Manage screenshots',
        group: 'Content',
        dependentPermissions: ['branches_main_modify'],
        newPermission: false,
        doesSetAllReadOnlyLanguages: false,
        description: null,
    },
    {
        id: 'contributors',
        scope: 'project',
        title: 'Manage contributors',
        group: 'Project',
        dependentPermissions: [],
        newPermission: false,
        doesSetAllReadOnlyLanguages: false,
        description: null,
    },
    {
        id: 'branches_create',
        scope: 'project',
        title: 'Create branches',
        group: 'Branches',
        dependentPermissions: [],
        newPermission: false,
        doesSetAllReadOnlyLanguages: true,
        description: null,
    },
    {
        id: 'branches_merge',
        scope: 'project',
        title: 'Merge branches',
        group: 'Branches',
        dependentPermissions: ['branches_main_modify'],
        newPermission: true,
        doesSetAllReadOnlyLanguages: true,
        description: null,
    },
    {
        id: 'manage_languages',
        scope: 'project',
        title: 'Manage languages',
        group: 'Project',
        dependentPermissions: ['branches_main_modify'],
        newPermission: false,
        doesSetAllReadOnlyLanguages: true,
        description: null,
    },
    {
        id: 'review',
        scope: 'project',
        title: 'Review',
        group: 'Review',
        dependentPermissions: [],
        newPermission: false,
        doesSetAllReadOnlyLanguages: false,
        description: null,
    },
    {
        id: 'branches_main_modify',
        scope: 'project',
        title: 'Contribute to main branch',
        group: 'Branches',
        dependentPermissions: [],
        newPermission: false,
        doesSetAllReadOnlyLanguages: false,
        description: null,
    },
    {
        id: 'custom_status_modify',
        scope: 'project',
        title: 'Change custom status',
        group: 'Review',
        dependentPermissions: [],
        newPermission: true,
        doesSetAllReadOnlyLanguages: false,
        description: null,
    },
];

export const permissionsTagsMock = permissionsMock.map((permission) => ({
    ...permission,
    enabled: true,
    checked: true,
}));

export const contributorsMock: ContributorType[] = [
    {
        id: 114330,
        avatar: 'https://www.gravatar.com/avatar/2fb76ddb5fb51821b58819c9900be54c?d=retro\u0026s=100',
        name: 'Mohamed Mounir',
        email: 'mohamed.mounir@lokalise.com',
        isPending: false,
        isReinvited: false,
        allReadOnlyLanguages: false,
        allEditableLanguages: true,
        roleId: null,
        readOnlyLanguages: [
            {
                id: '717',
                name: 'Arabic',
                isoCode: 'ar',
            },
            {
                id: '640',
                name: 'English',
                isoCode: 'en',
            },
            {
                id: '672',
                name: 'German',
                isoCode: 'de',
            },
            {
                id: '736',
                name: 'Italian',
                isoCode: 'it_IT',
            },
            {
                id: '1056',
                name: 'Spanish',
                isoCode: 'es',
            },
        ],
        editableLanguages: [],
        permissions: [
            {
                id: 'tasks',
                scope: 'project',
                title: 'Manage tasks',
                group: 'Project',
                checked: false,
                enabled: true,
            },
            {
                id: 'upload',
                scope: 'project',
                title: 'Upload files',
                group: 'Content transfer',
                checked: false,
                enabled: true,
            },
            {
                id: 'activity',
                scope: 'project',
                title: 'View activity',
                group: 'Activity',
                checked: false,
                enabled: true,
            },
            {
                id: 'download',
                scope: 'project',
                title: 'Download files',
                group: 'Content Transfer',
                checked: false,
                enabled: true,
            },
            {
                id: 'glossary_edit',
                scope: 'project',
                title: 'Glossary',
                group: 'Add and edit glossary terms',
                checked: false,
                enabled: true,
            },
            {
                id: 'glossary_delete',
                scope: 'project',
                title: 'Delete glossary terms',
                group: 'Glossary',
                checked: false,
                enabled: true,
            },

            {
                id: 'settings',
                scope: 'project',
                title: 'Manage project settings',
                group: 'Project',
                checked: false,
                enabled: true,
            },
            {
                id: 'statistics',
                scope: 'project',
                title: 'View statistics',
                group: 'Activity',
                checked: false,
                enabled: true,
            },
            {
                id: 'manage_keys',
                scope: 'project',
                title: 'Manage keys',
                group: 'Content',
                checked: false,
                enabled: true,
            },
            {
                id: 'screenshots',
                scope: 'project',
                title: 'Manage screenshots',
                group: 'Content',
                checked: false,
                enabled: true,
            },
            {
                id: 'contributors',
                scope: 'project',
                title: 'Manage contributors',
                group: 'Project',
                checked: false,
                enabled: true,
            },
            {
                id: 'branches_create',
                scope: 'project',
                title: 'Create branches',
                group: 'Branches',
                checked: false,
                enabled: true,
            },
            {
                id: 'branches_merge',
                scope: 'project',
                title: 'Merge branches',
                group: 'Branches',
                checked: false,
                enabled: true,
            },
            {
                id: 'manage_languages',
                scope: 'project',
                title: 'Manage languages',
                group: 'Project',
                checked: false,
                enabled: true,
            },
            {
                id: 'review',
                scope: 'project',
                title: 'Review',
                group: 'Review',
                checked: false,
                enabled: true,
            },
            {
                id: 'branches_main_modify',
                scope: 'project',
                title: 'Contribute to main branch',
                group: 'Branches',
                checked: false,
                enabled: true,
            },
            {
                id: 'custom_status_modify',
                scope: 'project',
                title: 'Change custom status',
                group: 'Review',
                checked: false,
                enabled: true,
            },
        ],
        owner: false,
        userGroups: [],
        alphaProvider: false,
    },
    {
        id: 114331,
        avatar: 'https://www.gravatar.com/avatar/69ee3e64a4a00ae0af9fb514cc07b3a4?d=retro\u0026s=100',
        name: 'Mou',
        email: 'mou@lokalise.com',
        isPending: false,
        isReinvited: false,
        allReadOnlyLanguages: false,
        allEditableLanguages: false,
        roleId: null,
        readOnlyLanguages: [
            {
                id: '640',
                name: 'English',
                isoCode: 'en',
            },
            {
                id: '717',
                name: 'Arabic',
                isoCode: 'ar',
            },
        ],
        editableLanguages: [],
        permissions: [
            {
                id: 'tasks',
                scope: 'project',
                title: 'Manage tasks',
                group: 'Project',
                checked: true,
                enabled: true,
            },
            {
                id: 'upload',
                scope: 'project',
                title: 'Upload files',
                group: 'Content transfer',
                checked: false,
                enabled: true,
            },
            {
                id: 'activity',
                scope: 'project',
                title: 'View activity',
                group: 'Activity',
                checked: false,
                enabled: true,
            },
            {
                id: 'download',
                scope: 'project',
                title: 'Download files',
                group: 'Content Transfer',
                checked: false,
                enabled: true,
            },
            {
                id: 'glossary_edit',
                scope: 'project',
                title: 'Glossary',
                group: 'Add and edit glossary terms',
                checked: true,
                enabled: true,
            },
            {
                id: 'glossary_delete',
                scope: 'project',
                title: 'Delete glossary terms',
                group: 'Glossary',
                checked: true,
                enabled: true,
            },
            {
                id: 'settings',
                scope: 'project',
                title: 'Manage project settings',
                group: 'Project',
                checked: true,
                enabled: true,
            },
            {
                id: 'statistics',
                scope: 'project',
                title: 'View statistics',
                group: 'Activity',
                checked: true,
                enabled: true,
            },
            {
                id: 'manage_keys',
                scope: 'project',
                title: 'Manage keys',
                group: 'Content',
                checked: true,
                enabled: true,
            },
            {
                id: 'screenshots',
                scope: 'project',
                title: 'Manage screenshots',
                group: 'Content',
                checked: true,
                enabled: true,
            },
            {
                id: 'contributors',
                scope: 'project',
                title: 'Manage contributors',
                group: 'Project',
                checked: true,
                enabled: true,
            },
            {
                id: 'branches_create',
                scope: 'project',
                title: 'Create branches',
                group: 'Branches',
                checked: true,
                enabled: true,
            },
            {
                id: 'branches_merge',
                scope: 'project',
                title: 'Merge branches',
                group: 'Branches',
                checked: true,
                enabled: true,
            },
            {
                id: 'manage_languages',
                scope: 'project',
                title: 'Manage languages',
                group: 'Project',
                checked: true,
                enabled: true,
            },
            {
                id: 'review',
                scope: 'project',
                title: 'Review',
                group: 'Review',
                checked: true,
                enabled: true,
            },
            {
                id: 'branches_main_modify',
                scope: 'project',
                title: 'Contribute to main branch',
                group: 'Branches',
                checked: true,
                enabled: true,
            },
            {
                id: 'custom_status_modify',
                scope: 'project',
                title: 'Change custom status',
                group: 'Review',
                checked: true,
                enabled: true,
            },
        ],
        owner: true,
        userGroups: [],
        alphaProvider: false,
    },
    {
        id: 114332,
        avatar: 'https://www.gravatar.com/avatar/e494b8b466e33c9068656172edc4544e?d=retro\u0026s=100',
        name: 'Mou+1',
        email: 'mou+1@lokalise.com',
        isPending: true,
        isReinvited: false,
        allReadOnlyLanguages: false,
        allEditableLanguages: false,
        roleId: null,
        readOnlyLanguages: [],
        editableLanguages: [
            {
                id: '640',
                name: 'English',
                isoCode: 'en',
            },
            {
                id: '717',
                name: 'Arabic',
                isoCode: 'ar',
            },
        ],
        permissions: [],
        owner: false,
        userGroups: [],
        alphaProvider: false,
    },
];
